<template>
  <div class="img-loader" @change="change" @dragover="dragover" @drop="drop">
    <p>{{ $t('components.imgLoader.tip1') }}
      <label class="browse">
        {{ $t('components.imgLoader.tip2') }}...
        <input id="file" class="sr-only" type="file" accept="image/*" />
      </label>
    </p>
  </div>
</template>

<script>
export default {
  name: "img-loader",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    read(files) {
      return new Promise((resolve, reject) => {
        if (!files || files.length === 0) {
          resolve();
          return;
        }
        const file = files[0];
        if (/^image\/\w+$/.test(file.type)) {
          if (URL) {
            resolve({
              loaded: true,
              name: file.name,
              type: file.type,
              url: URL.createObjectURL(file),
            });
          } else {
            reject(new Error(this.$t('components.imgLoader.unsupportedErr')));
          }
        } else {
          reject(new Error(this.$t('components.imgLoader.imgTypeErr')));
        }
      });
    },
    change({ target }) {
      this.read(target.files).then((data) => {
        target.value = '';
        this.update(data);
      }).catch((e) => {
        target.value = '';
        this.alert(e);
      });
    },
    dragover(e) {
      e.preventDefault();
    },
    drop(e) {
      e.preventDefault();
      this.read(e.dataTransfer.files)
        .then((data) => {
          this.update(data);
        })
        .catch(this.alert);
    },
    alert(e) {
      const msg = e && e.message ? e.message : e;
      this.$message({
        message: msg,
        type: 'warning',
        center: true
      });
    },
    update(data) {
      Object.assign(this.data, data);
    },
  }
};
</script>

<style scoped>
.img-loader {
  display: table;
  height: 100%;
  overflow: hidden;
  width: 100%;
  border: 1px dashed #999;
  border-radius:20px;
  -moz-border-radius:20px; /* Old Firefox */
}
.img-loader:hover {
  border-color: #08f;
}
.img-loader > p {
  color: #999;
  display: table-cell;
  line-height: 30em;
  text-align: center;
  vertical-align: middle;
}
.browse {
  color: #0074d9;
  cursor: pointer;
  margin-left: .25rem;
}
.browse:hover {
    color: #08f;
    text-decoration: underline;
}
.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
</style>